import cx from 'classnames'
import type React from 'react'

import css from './Placeholder.module.scss'

type Props = {
  active: boolean
  disabled: boolean
  onClick: () => void
}

const Placeholder: React.FC<Props> = ({ active, disabled, onClick }) => {
  if (active) {
    return null
  }

  return (
    <div
      className={cx(css.wrapper, { [css.disabled]: disabled })}
      onClick={onClick}
    >
      Add a comment...
    </div>
  )
}

export default Placeholder
